export default __webpack_public_path__ + "ZapWorks-small.png";